import { Injectable } from '@angular/core';
import { TokenStorageService } from './token-storage.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  constructor(private tokenStorage: TokenStorageService) {}
  isAdmin(): boolean {
    const role = this.tokenStorage.getRole();
    return role === 'ADMIN_ROLE';
  }

  isVendor(): boolean {
    const role = this.tokenStorage.getRole();
    return role === 'VENDOR_ROLE';
  }

  isTechnician(): boolean {
    const role = this.tokenStorage.getRole();
    return role === 'TECHNICIAN_ROLE';
  }
}
